import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';

import type { CompanyHubSpaceQuery as CompanyHubSpaceQueryType } from './__types__/CompanyHubSpaceQuery.ts';
import { CompanyHubSpaceQuery } from './CompanyHubSpaceQuery.graphql.ts';

export async function checkIfCompanyHubSpaceExists(): Promise<boolean> {
	const key = getCompanyHubSpaceKey();
	if (!key) {
		throw new Error('Failed to get company hub space key');
	}

	try {
		// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
		const { data } = await getApolloClient().query<CompanyHubSpaceQueryType>({
			query: CompanyHubSpaceQuery,
			variables: { key },
		});
		return !!data?.space?.id;
	} catch (error) {
		if (error?.message.includes('NotFoundException')) {
			markErrorAsHandled(error);
			return false;
		} else {
			throw error;
		}
	}
}
